import React from "react";

import DashboardShell from "./DashboardShell";

const Content: React.FC = () => <DashboardShell breadCrumbDefault />;

export default Content;
